import parse from "html-react-parser";
import { t } from "i18next";
import React from "react";
import { useNavigate } from "react-router-dom";
import "simplebar-react/dist/simplebar.min.css";

import type { ICustomerQuery } from "@repo/shopifyV2/interface/customer";

import Button from "@atoms/Button";
import Link from "@atoms/Link";

import { URLS } from "@const/urls";

import useLanguage from "@hooks/useLanguage";

import { useCustomerStore } from "@store/customer";
import { useLayoutStore } from "@store/layout";

export default function Contact() {
  const navigate = useNavigate();

  const { lang } = useLanguage();

  const { openAccount } = useLayoutStore();
  const { customer } = useCustomerStore();

  const handleAccount = (_accessToken?: string, fetchedCustomer?: ICustomerQuery["customer"]) => {
    const _customer = fetchedCustomer ?? customer;
    if (!_customer?.id) {
      sessionStorage.setItem("loginAfterUrl", URLS.ORDER_HISTORY);
      openAccount(true);
      return;
    }

    navigate(URLS.ORDER_HISTORY);
  };

  return (
    <>
      <h2 className="text-title pc:col-span-10 pc:flex col-span-8 hidden">Contact</h2>
      <section className="pc:col-span-10 col-span-8 grid grid-cols-subgrid gap-y-10 wrap-break-word">
        <article className="pc:col-span-3 col-span-8 flex flex-col gap-2.5 leading-5">
          {parse(t("contact.description"))}

          <Button
            as="square"
            onClick={() => {
              handleAccount();
            }}
            variant="secondary"
          >
            {t("contact.order_history")}
          </Button>
        </article>

        <section className="pc:col-span-6 col-span-8 grid grid-cols-subgrid gap-y-10">
          <article className="pc:col-span-6 col-span-8 grid h-fit grid-cols-subgrid gap-y-2.5">
            <span className="pc:col-span-6 col-span-8">Customer Care</span>

            <div className="pc:col-span-6 col-span-8 grid grid-cols-subgrid gap-y-1.5">
              {lang !== "jp" && (
                <>
                  <span className="pc:col-span-1 col-span-2">Chat</span>
                  <Link as="text" className="pc:col-span-5 col-span-6" href={`https://${t("information.channel_talk")}`}>
                    {t("information.channel_talk")}
                  </Link>
                </>
              )}

              <span className="pc:col-span-1 col-span-2">Email</span>
              <Link as="text" className="pc:col-span-5 col-span-6" href={`mailto:${t("information.email")}`}>
                {t("information.email")}
              </Link>

              <span className="pc:col-span-1 col-span-2">Hours</span>
              <div className="pc:col-span-5 col-span-6 flex flex-col gap-1.5">
                <span> {t("contact.working_hours")}</span>
                {lang !== "jp" ? <span className="text-dark-grey">{t("contact.cs_info")}</span> : null}
              </div>
            </div>
          </article>

          {lang !== "jp" && (
            <section className="pc:col-span-6 col-span-8 grid h-fit grid-cols-subgrid gap-y-2.5">
              <span className="pc:col-span-6 col-span-8">Wholesale & Inquiries</span>
              <span className="pc:col-span-1 col-span-2">Email</span>
              <Link as="text" className="pc:col-span-5 col-span-6" href="mailto:info@thisisneverthat.com">
                info@thisisneverthat.com
              </Link>
            </section>
          )}
        </section>
      </section>
    </>
  );
}
